import getClauseIdsForSectionType from './getClauseIdsForSectionType';
import store from '../../store/store';
export default function getExistingClauseTypesInSection(sectionType) {
    var existingClauseTypesMap = new Map();
    var clauseIds = getClauseIdsForSectionType(sectionType);
    for (var _i = 0, clauseIds_1 = clauseIds; _i < clauseIds_1.length; _i++) {
        var clauseId = clauseIds_1[_i];
        var clause = store.inboxRulesEditState.clauseMap.get(clauseId);
        existingClauseTypesMap.set(clause.clauseType, clauseId);
    }
    return existingClauseTypesMap;
}
//# sourceMappingURL=getExistingClauseTypesInSection.js.map